# frozen_string_literal: true

module Engine
  module Game
    module G18Carolinas
    end
  end
end
